var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.Search.DepartmentSearch = function (superClass) {
  extend(DepartmentSearch, superClass);
  function DepartmentSearch() {
    return DepartmentSearch.__super__.constructor.apply(this, arguments);
  }
  DepartmentSearch.prototype.initialize = function (options) {
    var dept, initialData;
    this.universityId = options.universityId;
    this.allowCreation = options.allowCreation;
    dept = options.department;
    if (dept != null ? dept.name : void 0) {
      initialData = {
        id: dept.id || -1,
        name: dept.name
      };
    }
    _.defaults(options, {
      placeholder: 'Department',
      ajax: {
        url: "/ac_university_departments/" + this.universityId,
        data: function (_this) {
          return function (term, page) {
            return {
              q: term
            };
          };
        }(this),
        results: function (_this) {
          return function (data, page) {
            return {
              results: data.results
            };
          };
        }(this)
      },
      initSelection: function (element, callback) {
        if (initialData) {
          return callback(initialData);
        }
      }
    });
    if (this.allowCreation) {
      this.createNewView = new Search.CreateDepartment({
        save: function (_this) {
          return function (name) {
            return _this.$el.select2('data', {
              id: -1,
              name: name
            }, true);
          };
        }(this)
      });
      this.createNewView.render();
    }
    DepartmentSearch.__super__.initialize.apply(this, arguments);
    if (initialData) {
      return this.$el.select2('data', initialData, true);
    }
  };
  DepartmentSearch.prototype.formatSelection = function (dept, container, escapeMarkup) {
    return escapeMarkup(dept.name);
  };
  DepartmentSearch.prototype.formatResult = function (dept, container, query, escapeMarkup) {
    return escapeMarkup(dept.name);
  };
  DepartmentSearch.prototype.opening = function () {
    if (this.allowCreation) {
      return this._addCreateNewButtonToFooter(this.$el.select2("container").find(".select2-drop"));
    }
  };
  DepartmentSearch.prototype._addCreateNewButtonToFooter = function (dropdown) {
    if (dropdown.find('#affiliation-editor-create-department-btn').length > 0) {
      return;
    }
    dropdown.append('<div class="select2-footer"> <a id="affiliation-editor-create-department-btn" class="text-gray-dark"> Or create a new department... </a> </div>');
    return dropdown.find("#affiliation-editor-create-department-btn").click(function (_this) {
      return function () {
        _this.createNewView.show(_this.currentSearchString());
        return _this.$el.select2('close');
      };
    }(this));
  };
  return DepartmentSearch;
}(window.Search.Base);
window.extend = extend;
window.hasProp = hasProp;